<template>
  <nav
    aria-label="pagination"
    class="jade-pagination"
  >
    <jade-icon-button
      size="medium"
      icon="chevron-left"
      variant="neutral-subtle"
      :disabled="disabledPrevious"
      data-testid="button-previous"
      @click="$emit('onPrevious')"
    />
    <slot></slot>
    <jade-icon-button
      size="medium"
      icon="chevron-right"
      variant="neutral-subtle"
      :disabled="disabledNext"
      data-testid="button-next"
      @click="$emit('onNext')"
    />
  </nav>
</template>

<script>
import JadeIconButton from '../JadeIconButton'

export default {
  name: 'JadePagination',
  components: {
    JadeIconButton
  },
  props: {
    disabledPrevious: Boolean,
    disabledNext: Boolean
  }
}
</script>
